import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

function ZoneIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 25" width="24" height="25" {...props}>
      <path
        d="M5 3.49997C3.90694 3.49997 3 4.38747 3 5.45711V19.1571C3 20.2268 3.90694 21.1143 5 21.1143H19C20.0931 21.1143 21 20.2268 21 19.1571V5.45711C21 4.38747 20.0931 3.49997 19 3.49997H15V5.45711H19V11.3285H17V13.2857H19V19.1571H12V13.2857H14V11.3285H8V13.2857H10V19.1571H5V5.45711H9.58594L12.5762 8.38327L13.9902 6.99951L10.4141 3.49997H5Z"
        fill="#5958CF"
      />
    </SvgIcon>
  );
}

export default ZoneIcon;
